module.exports = __webpack_public_path__ + "static/img/P3.69578b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/P3.png
// module id = etft
// module chunks = 0